import { useEffect, useState } from 'react';
import { postMessageGtag } from '../utils/trackClick';
import { useHistory } from 'react-router-dom';

export const useDetectBrowserBack = () => {
  const history = useHistory();
  const [isMobile, setIsMobile] = useState<boolean>(false);

  // デバイス判定関数
  const checkDevice = () => {
    const width = window.innerWidth;
    // 767px以下をスマホと判定
    setIsMobile(width <= 767);
  };

  useEffect(() => {
    // 初回のデバイス判定
    checkDevice();

    // 初回表示時に履歴を積んでおく（Safari対応）
    if (window.history.state === null) {
      // 履歴の最初の状態を記録
      window.history.replaceState({ page: 'main' }, '', '');
      // 戻るボタンを押した時に popstate が発火するように履歴を積む
      window.history.pushState({ page: 'dummy' }, '', '');
    }

    const popHistoryListen = history.listen((location, action) => {
      if (action === 'POP') {
        const mobile = isMobile ? 'sp' : 'pc';
        postMessageGtag('click_browser_back_' + mobile, 'detailSettings');
        history.push('/');
      }
    });

    // ウィンドウサイズの変更に応じて判定
    window.addEventListener('resize', checkDevice);

    // コンポーネントのクリーンアップ
    return () => {
      window.removeEventListener('resize', checkDevice);
      popHistoryListen();
    };
  }, [history, isMobile]);
};
